import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnnouncementStatus } from '@models/announcement';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { tap } from 'rxjs/operators';
import { AnnouncementDialogService } from './announcement-dialog.service';

@UntilDestroy()
@Component({
  selector: 'app-announcement-dialog',
  templateUrl: './announcement-dialog.component.html',
  styleUrls: ['./announcement-dialog.component.scss'],
})
export class AnnouncementDialogComponent implements OnInit, OnDestroy {
  formGroup = new FormGroup({
    id: new FormControl(),
    title: new FormControl(null, Validators.required),
    description: new FormControl(null, Validators.required),
    status: new FormControl(),
    isActive: new FormControl(true),
    previousAnnouncementId: new FormControl(),
    concurrencyToken: new FormControl(),
  });
  STATUS = AnnouncementStatus;

  constructor(
    public presenter: AnnouncementDialogService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.updateFormGroupOnAnnouncementChange();
  }

  ngOnDestroy(): void {
    // Reserve for `untilDestroyed()` operator.
  }

  onSave(): void {
    const value = this.formGroup.value;
    value.status = AnnouncementStatus.DRAFT;
    this.presenter.save(value);
  }

  onPublish(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('MESSAGE__INVALID_FORM'),
      });
      return;
    }
    const value = this.formGroup.value;
    value.status = AnnouncementStatus.PUBLISHED;
    this.presenter.save(value);
  }

  onCancel(): void {
    this.presenter.close();
  }

  private updateFormGroupOnAnnouncementChange(): void {
    this.presenter.announcement$
      .pipe(
        tap(() => this.formGroup.reset()),
        tap((announcement) => this.formGroup.patchValue(announcement)),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
